import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { PrototypeBanner } from "@/components/PrototypeBanner";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { /* transient error, will retry */ }
      if (++tries < 8) setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once per session_id; poll is a stable inner fn, api is a module import
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#EAF3EF] flex flex-col">
      <PrototypeBanner />
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="bg-white rounded-2xl border border-[#D2E3DB] shadow-sm p-10 max-w-md w-full text-center">
          <div className="mb-6 flex justify-center"><Logo /></div>
          {status === "checking" && (<><Loader2 className="h-14 w-14 animate-spin text-[#087A73] mx-auto mb-4" /><h1 className="text-xl font-bold text-[#102A2A]">Verifica del pagamento...</h1><p className="text-[#5C6B68] mt-2">Attendere qualche istante.</p></>)}
          {status === "paid" && (<><CheckCircle2 className="h-16 w-16 text-[#087A73] mx-auto mb-4" data-testid="payment-success-icon" /><h1 className="text-2xl font-bold text-[#102A2A]">Pagamento completato!</h1><p className="text-[#5C6B68] mt-2">La tua prenotazione è stata registrata. Il professionista confermerà a breve.</p><Button data-testid="go-bookings" onClick={() => navigate("/paziente/prenotazioni")} className="mt-6 bg-[#087A73] text-white rounded-xl h-12 px-6 w-full">Vai alle prenotazioni</Button></>)}
          {(status === "error" || status === "timeout") && (<><XCircle className="h-16 w-16 text-[#C0392B] mx-auto mb-4" /><h1 className="text-xl font-bold text-[#102A2A]">Verifica non riuscita</h1><p className="text-[#5C6B68] mt-2">Non siamo riusciti a confermare il pagamento. Controlla le tue prenotazioni.</p><Button onClick={() => navigate("/paziente/prenotazioni")} className="mt-6 bg-[#087A73] text-white rounded-xl h-12 px-6 w-full">Le mie prenotazioni</Button></>)}
        </div>
      </div>
    </div>
  );
}
